import { useAppSelector } from '#components/redux/hooks';
import { REDUCER_ADVERT_FAVORITE_NAME } from '#advertFavorite/constants';

const useAdvertFavoriteState = () => useAppSelector((state) => state[REDUCER_ADVERT_FAVORITE_NAME]);

export { useAdvertFavoriteState };
